import { render, staticRenderFns } from "./InternetMovil.vue?vue&type=template&id=6329a2c1&scoped=true&"
import script from "./InternetMovil.vue?vue&type=script&lang=js&"
export * from "./InternetMovil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6329a2c1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
